import { POSMaterialImageSaveObject } from './POSImageMaterial';
import { Utils } from '../../../core/services/utils.service';

export interface POSMaterialSaveObject {
	x: number;
	y: number;
	name: string;
	angle: number;
	width: number;
	height: number;
}

export interface POSImageMaterialDragData {
	element: POSMaterialImageSaveObject;
	type: 'POSImageMaterial';
}

export interface POSMaterialTableItem {
	key: number;
	name: {
		disabled: false;
		dtype: 'tooltip';
		image: string;
		value: string;
	};
	clickable_params: {
		material: POSMaterialImageSaveObject;
		dragData?: POSImageMaterialDragData;
	}
}

export class POSMaterial {

	private _x: number;
	private _y: number;
	private _angle: number;
	private _name: string;
	private _width: number;
	private _height: number;

	public set x(value: number) {
		this._x = Utils.round(value ?? -0.15);
	}

	public get x(): number {
		return this._x;
	}

	public set y(value: number) {
		this._y = Utils.round(value ?? 0);
	}

	public get y(): number {
		return this._y;
	}

	public set angle(value: number) {
		this._angle = value ?? 0;
	}

	public get angle(): number {
		return this._angle;
	}

	public set name(value: string) {
		this._name = value ?? '';
	}

	public get name(): string {
		return this._name;
	}

	set width(width: number) {
		this._width = width ?? 0.5;
	}

	get width(): number {
		return this._width;
	}

	set height(height: number) {
		this._height = height ?? 0.5;
	}

	get height(): number {
		return this._height;
	}

	constructor(params: Partial<POSMaterialSaveObject> = {}) {
		this.x = params.x;
		this.y = params.y;
		this.name = params.name;
		this.angle = params.angle;
		this.width = params.width;
		this.height = params.height;
	}

	public copy(): POSMaterial {
		return new POSMaterial(this.saveObject());
	}

	public saveObject(): POSMaterialSaveObject {
		return {
			x: this.x,
			y: this.y,
			angle: this.angle,
			name: this.name,
			width: this.width,
			height: this.height
		}
	}

	public planogramSaveObject(): Partial<POSMaterialSaveObject> {
		return this.saveObject();
	}

	public commonSaveObject(): Partial<POSMaterialSaveObject> {
		return this.saveObject();
	}
}